import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import '../../../common/Widgets/Links.scss';
import { ButtonBack } from '../../../common/Button/ButtonBack';
import { useNavigate } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import { SiteContext } from '../../../../context/SiteContext';
import { PageAbsolutePath } from '../../../../consts/Common';
import ViewDocument from '../../../common/ViewDocument/ViewDocument';
import { scrollToTop } from '../../../common/HelperMethods';

const DealerResourcesPage = () => {
  const { site } = useContext(SiteContext);

  const { brand } = site;

  const { brandPhoneNumbers, brandDisplayName } = brand;

  const phoneNumber = brandPhoneNumbers.quotesAndRenewalsNumber;

  const chevronRightComponent = <FontAwesomeIcon icon={faChevronRight} />;
  const navigate = useNavigate();

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <>
      <div>
        <table className='dealer-resource-page'>
          <tr>
            <td colSpan={2}>
              <h2>Marketing materials</h2>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <hr />
            </td>
          </tr>
          <tr>
            <td className='expand'>
              <p>{brandDisplayName} Insurance Leaflet</p>
            </td>
            <td className='fixed'>
              <div className='dealer-link-item'>
                <span className='dealer-link-icon'>
                  {chevronRightComponent}
                </span>
                <ViewDocument
                  path={`docs/${site.brand.brandName.toLowerCase()}/Insurance Leaflet 24-06.pdf`}
                  documentName='Download PDF'
                />
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <hr />
            </td>
          </tr>
          <tr>
            <td className='expand'>
              <p>Excess return leaflet</p>
            </td>
            <td className='fixed'>
              <div className='dealer-link-item'>
                <span className='dealer-link-icon'>
                  {chevronRightComponent}
                </span>
                <ViewDocument
                  path={`docs/${site.brand.brandName.toLowerCase()}/Excess Return Leaflet 24-04.pdf`}
                  documentName='Download PDF'
                />
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <hr />
            </td>
          </tr>
          <tr>
            <td className='expand'>
              <p>Order free marketing material</p>
            </td>
            <td className='fixed'>
              <div>
                <p>0333 320 5423</p>
                <p>Mon–Fri 9am–5pm</p>
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <hr />
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <h2>Policy documents and IPID statement</h2>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <hr />
            </td>
          </tr>
          <tr>
            <td className='expand'>
              <p>
                To view policy documents and IPID statement please click{' '}
                <Link
                  className='in-text'
                  to={PageAbsolutePath.Insurance.PolicyDocuments}>
                  {'here'}
                </Link>
              </p>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <hr />
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <h2>Administration</h2>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <hr />
            </td>
          </tr>
          <tr>
            <td className='expand'>
              <p>Customer proposal form</p>
            </td>
            <td className='fixed'>
              <div className='dealer-link-item'>
                <span className='dealer-link-icon'>
                  {chevronRightComponent}
                </span>
                <ViewDocument
                  path={`docs/${site.brand.brandName.toLowerCase()}/317724 Customer Proposal Form_1123.pdf`}
                  documentName='Download PDF'
                />
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <hr />
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <h2>Training aids</h2>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <hr />
            </td>
          </tr>
          <tr>
            <td className='expand'>
              <p>
                UK Insurers policy wordings summary showing non-use of{' '}
                {brandDisplayName} parts
              </p>
            </td>
            <td className='fixed'>
              <div className='dealer-link-item'>
                <span className='dealer-link-icon'>
                  {chevronRightComponent}
                </span>
                <ViewDocument
                  path={`docs/${site.brand.brandName.toLowerCase()}/Policy Wording Research 2024.pdf`}
                  documentName='Download PDF'
                />
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <hr />
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <h2>Recent Bulletins</h2>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <hr />
            </td>
          </tr>
          <tr>
            <td className='expand'>
              <p>Driveaway Insurance</p>
            </td>
            <td className='fixed'>
              <div className='dealer-link-item'>
                <span className='dealer-link-icon'>
                  {chevronRightComponent}
                </span>
                <Link className='in-text' to={''}>
                  {'Download PDF'}
                </Link>
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <hr />
            </td>
          </tr>
          {site.brand.brandName === 'kia' && (
            <>
              <tr>
                <td colSpan={2}>
                  <h2>Videos</h2>
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <hr />
                </td>
              </tr>
              <tr>
                <td className='expand'>
                  <p>Excess Return video</p>
                </td>
                <td className='fixed'>
                  <div className='dealer-link-item'>
                    <span className='dealer-link-icon'>
                      {chevronRightComponent}
                    </span>
                    <Link className='in-text' to={''}>
                      {'View'}
                    </Link>
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <hr />
                </td>
              </tr>
            </>
          )}
          <tr>
            <td className='expand'>
              <p>
                Paul Philpot, CEO {site.brand.brandDisplayName} UK on the
                importance of {site.brand.brandDisplayName} Insurance and Excess
                Return
              </p>
            </td>
            <td className='fixed'>
              <div className='dealer-link-item'>
                <span className='dealer-link-icon'>
                  {chevronRightComponent}
                </span>
                <Link className='in-text' to={''}>
                  {'View'}
                </Link>
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <hr />
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <h2>Contact</h2>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <hr />
            </td>
          </tr>
          <tr>
            <td className='expand'>
              <p>Your insurance business development manager</p>
            </td>
            <td className='fixed'>
              <div className='dealer-link-item'>
                <span className='dealer-link-icon'>
                  {chevronRightComponent}
                </span>
                <ViewDocument
                  path={`docs/${site.brand.brandName.toLowerCase()}/Business Development Managers 24-06.pdf`}
                  documentName='Download PDF'
                />
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <hr />
            </td>
          </tr>
          <tr>
            <td className='expand'>
              <p>Dealer support</p>
            </td>
            <td className='fixed'>
              <div>
                <a className='calltext' href={`tel:${phoneNumber}`}>
                  {phoneNumber}
                </a>
                <p>Mon–Thurs: 08.30–19.30,</p>
                <p>Fri: 09.00–18.00,</p>
                <p>Sat: 09.00–17.00</p>
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <hr />
            </td>
          </tr>
        </table>
        <ButtonBack
          name='btnBack'
          text='Back'
          onClick={() => navigate(-1)}
          additionalClassNames='btn-back'
        />
      </div>
    </>
  );
};

export default DealerResourcesPage;
